<template>
  <Dialog title="应用信息" width="600px" :visible.sync="dialogVisible" dialogType="dialog" showClose>
    <form class="apply-form">
      <div class="apply-title">{{ info.app_name }}</div>  
      <div class="form-group">
        <label class="name-label">APP_KEY：</label>
        <div class="controls">
          <span>{{ info.app_key }}</span>
          <div class="button">
            <div class="btn btn-copy" v-clipboard:copy="info.app_key" v-clipboard:success="onCopy">复制</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label">APP_SECRET：</label>
        <div class="controls">
          <span>{{ info.app_secret }}</span>
          <div class="button">
            <div class="btn btn-reset" @click="onReset">重置</div>
            <div class="btn btn-copy" v-clipboard:copy="info.app_secret" v-clipboard:success="onCopy">复制</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label">API请求速度：</label>
        <div class="controls">{{ info.request_speed_explain }}</div>
      </div>
      <div class="form-group">
        <label class="name-label">API请求量：</label>
        <div class="controls">{{ info.request_count_explain }}</div>
      </div>
      <div class="form-group">
        <div class="controls" style="text-align: center;">
          <button type="button" class="btn-apply" @click="closeDialog">确定</button>
        </div>
      </div>
    </form>
    <Dialog width="300px" :visible.sync="dialogTipVisible" :message="tip_msg"  dialogType="message"></Dialog>
  </Dialog>
</template>
<script>
import { appSecretReset } from '@/api/promotion'
import Dialog from '@/components/Dialog'
export default {
  name: 'CreateApply',
  components: {
    Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false   
    },
  },
  data() {
    return {
      info: {
        title: undefined,
        appKey: undefined,
        appSecret: undefined,
        request_speed: undefined,
        requests: undefined,
      },
      dialogVisible: this.visible,
      dialogTipVisible: false,
      tip_msg: undefined
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit('change', val)
    }
  },
  methods: {
    init(row) {
      this.info = row
    },  
    // 复制
    onCopy(e) {
      this.dialogTipVisible = true
      this.tip_msg = '已复制到剪切板'
    },
    // 重置
    onReset() {
      appSecretReset({
        app_key:this.info.app_key
      }).then(response => {
        this.$Message.success(response.message)
        this.info.app_secret = response.data.app_secret
        this.$emit('refreshList')
      }).catch(error => {
        console.log(error)
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped>
.apply-form{
  margin-top: 20px;
}
.apply-title{
  margin: 15px auto 25px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.form-group{
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-bottom: 10px;
}
.form-group::before,.form-group::after{
  content: " ";
  display: table;
  box-sizing: border-box;
}
.name-label {
  width: 20%;
  float: left;
  text-align: right;
  color: #222222;
  font-size: 13px;
  font-weight: normal;
  line-height: 30px;
  padding-right: 10px;
}
.controls{
  overflow: hidden;
  line-height: 30px;
  color: #999999;
}
.apply-tip{
  color: #999999;
  font-size: 12px;
}
.btn-apply{
  border-radius: 4px;
  background: #199ED8;
  color: #FFFFFF;
  padding: 10px 50px;
  font-size: 15px;
  line-height: 1.3333333;
  margin-top: 20px;
  cursor: pointer;
}
.button{
  display: inline-block;
  margin-left: 30px;
}
.button .btn{
  display: inline-block;
  margin-left: 20px;
  padding: 0 10px;
  border-radius: 25px;
  line-height: 25px;
  font-size: 12px;
  cursor: pointer;
}
.button .btn-copy{
  border: 1px solid rgba(255, 102, 0, 0.898039215686275);
  color: rgba(255, 102, 0, 0.898039215686275);
}
.button .btn-reset{
  color: #ffffff;
  border: 1px solid #199ED8;  
  background: #199ED8;  
}
</style>


// WEBPACK FOOTER //
// src/components/document/user/ApplyInfo.vue